import { useState, useCallback, useMemo } from 'react';
import { DrgView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Hook for managing DRG code search and filtering
 */
export function useDrgSearch(drgs: DrgView[]) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredDrgs = useMemo(() => {
    if (!searchTerm.trim()) return drgs;

    const searchLower = searchTerm.toLowerCase().trim();
    return drgs.filter(
      (drg) =>
        drg.code?.toLowerCase().includes(searchLower) ||
        drg.title?.toLowerCase().includes(searchLower) ||
        drg.grouperCode?.toLowerCase().includes(searchLower) ||
        drg.weight?.toString().includes(searchLower) ||
        drg.arithmeticMeanLOS?.toString().includes(searchLower)
    );
  }, [drgs, searchTerm]);

  const handleSearchChange = useCallback((value: string) => {
    setSearchTerm(value);
  }, []);

  const handleClearSearch = useCallback(() => {
    setSearchTerm('');
  }, []);

  return {
    searchTerm,
    filteredDrgs,
    handleSearchChange,
    handleClearSearch,
  };
}
